module.exports = __webpack_public_path__ + "static/media/twitter-white.245999f4.svg";